import { Navigate, useNavigate } from "@solidjs/router";
import { createMemo, Show } from "solid-js";
import { useI18n } from "@/api/i18n";
import { MetaTitleWithSeparator } from "@/domains/business/seo";
import { useRefineStore } from "../store/RefineProvider";
import { validateRefineState } from "../validators";
import { FinalPreviewStep } from "./steps/FinalPreviewStep";

export function RefinePreviewPage() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { state } = useRefineStore();

  // The preview can be opened directly (reload, link): the refine state is
  // rebuilt from the persisted draft, which may lack the category.
  const isValid = createMemo(() => validateRefineState(state).success);

  return (
    <Show
      when={isValid()}
      fallback={
        <Navigate href={`/job-offers/create/refine${window.location.search}`} />
      }
    >
      <MetaTitleWithSeparator>
        {t("jobOffers.refine.steps.finalPreview")}
      </MetaTitleWithSeparator>

      <div class="sticky top-0 z-10 border-b border-border bg-card">
        <div class="flex items-center gap-3 px-4 lg:px-8 py-3">
          <button
            type="button"
            class="flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground shrink-0"
            onClick={() => navigate(-1)}
          >
            <i class="ph ph-arrow-left text-base" />
          </button>
          <div class="min-w-0">
            <h1 class="text-base font-semibold leading-tight truncate">
              {t("jobOffers.refine.pageTitle")}
            </h1>
            <p class="text-xs text-muted-foreground leading-tight truncate">
              {t("jobOffers.refine.pageDescription")}
            </p>
          </div>
        </div>
      </div>

      <div class="max-w-3xl mx-auto px-4 py-8">
        <FinalPreviewStep />
      </div>
    </Show>
  );
}
